import { get } from 'lodash';

export default function getChildSku(productDetails) {
  const { options } = productDetails;
  const derivatives = get(productDetails, 'backOfPack.derivatives', {});

  let { derivativesTree } = derivatives;
  let node;

  if (!options) {
    return null;
  }

  for (const option of options) {
    node = derivativesTree.find((el) => el.index === parseInt(option, 10));
    if (!node) break;
    if (!node.children) {
      return node.sku;
    }
    derivativesTree = node.children;
  }

  return null;
}
